import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { UntypedFormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProductPage } from '../../generic/classes/product.page';
import { FilterService } from '../../generic/service/filter.service';
import { PaginationCommonDirective } from '../filters/pagination-common.directive';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
    selector: 'novi-product-pagination',
    templateUrl: 'product.pagination.component.html',
    styleUrls: ['./product.pagination.component.scss'],
    standalone: true,
    imports: [
        NgxPaginationModule,
        FormsModule,
        ReactiveFormsModule,
    ],
})
export class ProductPaginationComponent extends PaginationCommonDirective {
    private filterService = inject(FilterService);
    private formBuilder = inject(UntypedFormBuilder);

    @Input() pageData: ProductPage;
    @Input() showExtendedSearch: boolean;
    @Input() hasExtendedSearch: boolean;
    @Output() triggerSearchEvent: EventEmitter<boolean> =
        new EventEmitter<boolean>();

    constructor() {
        super();
        this.paginationForm = this.formBuilder.group({
            pageNumber: '',
        });
    }

    changePage(pageNumber) {
        this.filterService.changePage(pageNumber);
        this.getCurrentPageInput()?.setValue('');
    }

    triggerExtendedSearch(): void {
        this.triggerSearchEvent.emit(true);
    }
}
